import { styled } from 'styled-components'

// Styled component for color-coded table cells
export const ColoredCell = styled.div<{
  $backgroundColor: string
  $textColor: string
}>`
  padding: 4px 8px;
  border-radius: 4px;
  background-color: ${(props) => props.$backgroundColor};
  color: ${(props) => props.$textColor};
  font-weight: 500;
  display: inline-block;
`

// Wrapper to hide the column settings button
export const DataTableWrapper = styled.div`
  /* Hide the column settings button */
  & > div > div:first-child {
    display: none;
  }
`

// Print-specific wrapper to ensure proper spacing
export const CityAnalysisPrintWrapper = styled.div`
  @media print {
    page-break-inside: avoid;
    margin-bottom: 40px;
  }
`
